// extracted by mini-css-extract-plugin
export default {"container":"ID-z","modal":"JD-z","dimensions":"KD-z","brandName":"LD-z","productName":"MD-z","labelValue":"ND-z","recipientEmail":"OD-z","recommendedFit":"PD-z","hiddenField":"QD-z"};